exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#addMeasuringSeriesModal .v--modal-box.v--modal{min-width:380px!important;min-height:540px!important}#addMeasuringSeriesModal .modal__content{overflow-y:hidden!important}#addMeasuringSeriesModal .v-input__slot,#addMeasuringSeriesModal .v-input__slot label,#addMeasuringSeriesModal .v-select__slot,#addMeasuringSeriesModal .v-select__slot label{font-size:12px!important}#addMeasuringSeriesModal .menuable__content__active{max-height:200px!important}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-28cec04c","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/viewer/scada/modals/AddMeasuringSeries.vue
// module id = 1711
// module chunks = 0